<template>
    <v-container
        :fluid="content.fullWidth"
        :class="{
            'subhero-container': true,
            'pa-0': content.fullWidth,
            'pt-0': true,
        }"
    >
        <v-row column justify-center align-center no-gutters>
            <!-- <v-col cols="12" md="4" class="subhero-left">
                <div style="max-width: 200px">
                    THE BEST ELECTRICAL CONTROLS MANUFACTURER ON THE PLANET!
                </div>
            </v-col> -->
            <v-col cols="12" md="12" class="subhero-right">
                <v-container fluid class="pa-0 text-center">
                    <v-row
                        column
                        justify-center
                        align-center
                        no-gutters
                        class="justify-center"
                    >
                        <v-col
                            cols="12"
                            md="3"
                            lg="3"
                            xl="2"
                            class="subhero-left d-md-flex d-sm-none d-xs-none"
                        >
                            <div class="subhero-left-inner">
                                <TranslatableStringComponent
                                    :tstring="{ string: 'subHeroHeading' }"
                                />
                            </div>
                        </v-col>
                        <v-col cols="3" md="2" lg="2" sm="2" class="icon-blurb">
                            <fa
                                :icon="['fal', 'certificate']"
                                class="fa-lg inline-color"
                                :color="colors.white"
                            /><br />
                            <TranslatableBlockComponent
                                :tstring="{
                                    string: 'isoCertified',
                                }"
                                :includeClass="true"
                            />
                        </v-col>
                        <v-col cols="2" md="2" lg="2" sm="2" class="icon-blurb">
                            <fa
                                :icon="['fal', 'cogs']"
                                class="fa-lg inline-color"
                                :color="colors.white"
                            /><br />
                            <TranslatableBlockComponent
                                :tstring="{
                                    string: '15millionProductsConfiguration',
                                }"
                                :includeClass="true"
                            />
                        </v-col>
                        <v-col
                            cols="2"
                            xl="2"
                            md="1"
                            lg="1"
                            sm="2"
                            class="icon-blurb"
                        >
                            <fa
                                :icon="['fal', 'history']"
                                class="fa-lg inline-color"
                                :color="colors.white"
                            /><br />
                            <TranslatableBlockComponent
                                :tstring="{ string: 'lifetimeWarranty' }"
                                :includeClass="true"
                            />
                        </v-col>
                        <v-col cols="2" md="2" lg="2" sm="2" class="icon-blurb">
                            <fa
                                :icon="['fal', 'shipping-fast']"
                                class="fa-lg inline-color"
                                :color="colors.white"
                            /><br />
                            <TranslatableBlockComponent
                                :tstring="{
                                    string: 'guaranteedSameDayShipping',
                                }"
                                :includeClass="true"
                            />
                        </v-col>
                        <v-col cols="3" md="2" lg="2" sm="2" class="icon-blurb">
                            <fa
                                :icon="['fal', 'calculator']"
                                class="fa-lg inline-color"
                                :color="colors.white"
                            /><br />
                            <TranslatableBlockComponent
                                :tstring="{
                                    string: 'advantagePricingSaveUpto40',
                                }"
                                :includeClass="true"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <!-- <v-container>
                <v-row column justify-center align-center no-gutters>
                    <v-col cols="12">
                        Thing!
                    </v-col>
                </v-row>
            </v-container>
            <v-col cols="12" md="3" class="test">
                Test 123
            </v-col>
            <v-col cols="12" md="3" class="test">
                Test 123
            </v-col>
            <v-col cols="12" md="2" class="test">
                Test 123
            </v-col> -->
        </v-row>
        <!-- <v-row>
            <pre>{{ content }}</pre>
        </v-row> -->
    </v-container>
</template>
<script>
import colorUtilities from '~/mixins/colorUtilities'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
export default {
    name: 'SubHero',
    components: {
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    mixins: [colorUtilities],
    props: {
        content: {
            type: Object,
            default: null,
        },
        context: {
            type: String,
            default: '',
        },
    },
    computed: {},
    methods: {},
}
</script>
